export type BlogItemImage = {
  smallReference: string;
  mediumReference: string;
  largeReference: string;
  altText: string;
};

export type ArticleRibbonColor = "dark" | "light";

export type OldImageType = { fileReference?: string; file?: string };

export type ArticleImageType = BlogItemImage | OldImageType | null | undefined;

export type ArticleAEMData = {
  title: string;
  description: string;
  subtitle: string;
  image?: ArticleImageType;
  readTime: string;
  creationDate: string;
  path: string;
  articleType?: "article" | "video" | "quiz";
  articleId?: string;
  controlColor?: ArticleRibbonColor;
  showAuthor?: boolean;
  author?: string;
};
